var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _stateSubscription, _states, _subscriptions, _updates, _workflow;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet2(e, t) { var r = _classPrivateFieldGet(t, e); return _classApplyDescriptorGet(e, r); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { v4 as uuid } from 'uuid';
import { Subscription, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { set } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import workflow, { createState, initializeAction, ActionType, REFETCH_CARD_AFTER_MODAL_CLOSES_SCREENS } from '@banking/ui/workflows/card-settings/cancel-card';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import { createEmit, createSelect } from '@banking/ui/lib/workflow-ember/decorators';
import connect from '@banking/ui/lib/workflow-ember/connect';
import fetchMultipassStatus from '@banking/api/utils/multipass-status';
import analytics from '@banking/ui/workflows/card-settings/cancel-card/analytics';
const SERVICE_REGISTRY_KEY = 'card-management/cancel-card-modal';
let CancelCardModalState = (_dec = service('bbfrontend/v1/checking'), _dec2 = service('bbfrontend/v1/challenge'), _dec3 = service('bb-debit/card-management-service'), _class = (_stateSubscription = /*#__PURE__*/new WeakMap(), _states = /*#__PURE__*/new WeakMap(), _subscriptions = /*#__PURE__*/new WeakMap(), _updates = /*#__PURE__*/new WeakMap(), _workflow = /*#__PURE__*/new WeakMap(), class CancelCardModalState extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _stateSubscription, {
      writable: true,
      value: null
    });
    _classPrivateFieldInitSpec(this, _states, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: new Subscription()
    });
    _classPrivateFieldInitSpec(this, _updates, {
      writable: true,
      value: new Subject()
    });
    _classPrivateFieldInitSpec(this, _workflow, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "state", createState());
    _defineProperty(this, "doneCallback", () => {});
    _initializerDefineProperty(this, "addressFrontend", _descriptor, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor2, this);
    _initializerDefineProperty(this, "bbFrontendV1CheckingService", _descriptor3, this);
    _initializerDefineProperty(this, "bbFrontendChallengeApi", _descriptor4, this);
    _initializerDefineProperty(this, "cardManagementService", _descriptor5, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor6, this);
    _initializerDefineProperty(this, "dataApi", _descriptor7, this);
    _initializerDefineProperty(this, "intl", _descriptor8, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor9, this);
    _initializerDefineProperty(this, "multipassExternalApi", _descriptor10, this);
    _initializerDefineProperty(this, "sentry", _descriptor11, this);
    _initializerDefineProperty(this, "userInfo", _descriptor12, this);
    _classPrivateFieldSet(this, _stateSubscription, _classPrivateFieldGet2(this, _states).subscribe({
      next: state => set(this, 'state', state),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _updates).subscribe(updateLogger('Cancel Card Modal - Authorized User Card'));
    analytics(_classPrivateFieldGet2(this, _updates)).subscribe(params => this.dataApi.track(...params));
    this.reset();
  }
  willDestroy() {
    this.deinitialize();
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    super.willDestroy();
  }
  reset() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    _classPrivateFieldSet(this, _workflow, workflow(createState(), this.context));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).states.subscribe({
      next: next => _classPrivateFieldGet2(this, _states).next(next),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.subscribe(next => _classPrivateFieldGet2(this, _updates).next(next)));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.pipe(filter(([[_, next], action]) => action.type === ActionType.UserClickCloseModal && REFETCH_CARD_AFTER_MODAL_CLOSES_SCREENS.includes(next.navigation.current))).subscribe(() => this.doneCallback()));
  }
  emit(action) {
    _classPrivateFieldGet2(this, _workflow).emit(action);
  }
  openModal(balanceId, card, cardCustomization, cancellationType, unitToken, doneCallback = () => {}) {
    _classPrivateFieldGet2(this, _workflow).emit(initializeAction(balanceId, card, cardCustomization, cancellationType, unitToken));
    this.doneCallback = doneCallback;
  }
  get states() {
    return _classPrivateFieldGet2(this, _states).asObservable();
  }
  deinitialize() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    _classPrivateFieldGet2(this, _stateSubscription)?.unsubscribe();
  }
  get context() {
    return {
      applicationRouter: this.applicationRouter,
      createCard: this.cardManagementService.client.createCard.bind(this.cardManagementService.client),
      createCardCustomization: this.bizbankApi.client.createCardCustomization.bind(this.bizbankApi.client),
      getCustomizationSettings: this.bizbankApi.client.getCustomizationSettings.bind(this.bizbankApi.client),
      deactivateAccount: this.bbFrontendV1CheckingService.client.deactivateChecking.bind(this.bbFrontendV1CheckingService.client),
      intl: this.intl,
      fetchMultipassStatus,
      listCards: this.cardManagementService.client.listCards.bind(this.cardManagementService.client),
      lookupCountryAddressData: () => this.addressFrontend.lookupCountryAddressData(),
      marketToasts: this.marketToasts,
      multipass: this.multipassExternalApi.client,
      provideFeedback: this.bizbankApi.client.provideFeedback.bind(this.bizbankApi.client),
      terminateCard: this.cardManagementService.client.terminateCard.bind(this.cardManagementService.client),
      sentry: this.sentry,
      startChallenge: this.bbFrontendChallengeApi.client.startChallenge.bind(this.bbFrontendChallengeApi.client),
      userInfo: this.userInfo,
      uuid,
      validateAddress: this.bizbankApi.client.validateAddress.bind(this.bizbankApi.client)
    };
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "addressFrontend", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CheckingService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendChallengeApi", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "multipassExternalApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CancelCardModalState as default };
export const select = createSelect(SERVICE_REGISTRY_KEY);
export const emit = createEmit(SERVICE_REGISTRY_KEY);
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);